import HistoryDataList from "././components/HistoryTransferList";
import React, { useCallback, useRef ,useState } from "react";
import { DatePicker, Dialog, Toast ,SearchBar,Button} from "antd-mobile-v5";
import { useHistory } from "react-router-dom";
import { divide } from "lodash";
import { DeleteOutline } from "antd-mobile-icons";
import instance from "../../../../util/axios";


export default function CompletionList() {
  const history = useHistory();
  const datagridRef = useRef<any>(null);
  const [barWord, setBarWord] = useState<string>();
  const [keyword, setKeyword] = useState<string>();


  return (
    <>
      <div style={{ width: "100%", display: "inline-flex" }}>
            <SearchBar
              style={{ width: "85%", height: 50, fontSize: 16 }}
              value={barWord}
              key="1"
              placeholder="多个条件时以逗号分割"
              maxLength={20}
              onChange={(value) => {
                // setBarWord(value);
                setKeyword(value);
              }}
            />
            <Button
              style={{ width: "15%", height: 50, fontSize: 16 }}
              onClick={() => {
                setKeyword(barWord);
                // setPageIndex(1);
              }}
            >
              查询
            </Button>
       </div>
      <HistoryDataList
        url={`/erp/sku/workshop/getCompletionTransferFillingList?barWord=`+keyword}
        sorter={{ field: "createTime", order: "descend" }}
        descriptions={[
          {
            fieldName: "outWorkshopId",
            fieldShowName: "车间",
            width: 100,
            inputType: 6,
            dictionary: "erp_workshop",
            render: (item: any) => {
              return (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <span>{item.outWorkshopId}</span>
                  {item.status === "已保存" && (
                    <DeleteOutline
                      onClick={(e) => {
                        e.stopPropagation();
                        Dialog.confirm({
                          content: "确定要删除吗？",
                          onConfirm: () => {
                            instance
                              .get(
                                `/erp/sku/workshop/deleteCompletionTransferFilling?fillingId=${item.fillingId}`
                              )
                              .then((resp) => {
                                if (resp.data.Status === "1") {
                                  Toast.show({
                                    icon: "success",
                                    content: "删除成功",
                                  });
                                  datagridRef.current?.refresh();
                                }
                              });
                          },
                        });
                      }}
                    />
                  )}
                </div>
              );
            },
          },
          {
            fieldName: "creatorId",
            fieldShowName: "员工",
            width: 100,
            inputType: 6,
            dictionary: "base_staff",
          },

          {
            fieldName: "createTime",
            fieldShowName: "填报日期",
            width: 120,
          },
          {
            fieldName: "status",
            fieldShowName: "状态",
            width: 120,
          },
          {
            fieldName: "orderSerialNumber",
            fieldShowName: "订单",
            width: 100,
          },
          {
            fieldName: "radName",
            fieldShowName: "产品",
            width: 100,
          },
          {
            fieldName: "formulaNames",
            fieldShowName: "图号",
            width: 100,
          },
          {
            fieldName: "customText1s",
            fieldShowName: "规格",
            width: 100,
          },
        ]}
        ref={datagridRef}
        onClickRow={(info) => {
          history.push(`/erp/completion/historyNew/transferDetail/${info?.fillingId}`);
        }}
      />
    </>
  );
}
